module.exports = __webpack_public_path__ + "img/cli_04.4d577bcf.png";